import type { ReactNode } from 'react';

import styles from './Page.module.css';

const Page = ({ children }: { children: ReactNode }) => (
  <div className={styles.page}>{children}</div>
);

const Title = ({ children }: { children: ReactNode }) => (
  <h1 className={styles.title}>{children}</h1>
);

const Header = ({ children }: { children: ReactNode }) => (
  <div className={styles.header}>{children}</div>
);

const Content = ({
  children,
  hasPadding = true,
}: {
  children: ReactNode;
  hasPadding?: boolean;
}) => {
  const containerClasses = hasPadding
    ? `${styles.container} ${styles.containerPadding}`
    : styles.container;
  return <div className={containerClasses}>{children}</div>;
};

Page.Header = Header;
Page.Title = Title;
Page.Content = Content;

export default Page;
